// extracted by mini-css-extract-plugin
export default {"heading":"Confirmation_heading__hjaUN","icon":"Confirmation_icon__V905Y"};